module.exports = __webpack_public_path__ + "img/icon_3_41.3b183d5d.png";